import React from 'react'

// Khởi tạo Context
export const AppParamsContext = React.createContext(null)

export const AppParamsContextProvider = (props) => {
  
  // Thiết lập các giá trị mặc định cho môi trường Web thuần túy
  const contextValue = React.useMemo(() => {
    return {
      isWebView: false,        // Luôn là false vì không chạy trong Zalo
      isHeaderMiniApp: false,  // Không dùng Header của Mini App
      referUserId: undefined,
      referStationId: undefined,
      // Tạo các hàm giả (mock functions) để tránh lỗi crash code khi các trang khác gọi tới[cite: 1]
      checkUrlParam: () => undefined, 
      checkUrlParamSaveContext: () => undefined
    }
  }, [])

  return React.createElement(
    AppParamsContext.Provider,
    {
      value: contextValue
    },
    props.children
  )
}

// Hook để sử dụng context[cite: 1]
export const useAppParamsContext = () => {
  const context = React.useContext(AppParamsContext)
  if (!context) {
    throw new Error('useAppParamsContext must be used within AppParamsContextProvider')
  }
  return context
}